import React, { useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import StyledTabContainer from "../Common/StyledTabContainer";
import Subheading from "../Common/Subheading";
import SolutionsIcon from "../../assets/icons/componenets.svg2";
import MySolutionFilter from "../Solutions/MySolutionFilter";
import SystemSolutionsFilter from "../Solutions/SystemSolutionsFilter";

export default function SolutionsFilter({ filters, setFilters }) {
  const [search, setSearch] = useState("");
  useEffect(() => {
    const first = setTimeout(() => {
      setFilters({ ...filters, search, offset: 0 });
    }, 500);

    return () => {
      clearTimeout(first);
    };
  }, [search]);

  const tabs = [
    {
      eventKey: "my-solutions",
      heading: "My Solutions",
      subheading: "Select a pre-built Solution to suit your requirement .",
    },
    {
      eventKey: "system-solutions",
      heading: "System Solutions",
      subheading: "Browse and manage your components.",
    },
  ];

  return (
    <div>
      <div className="flex-grow-1 ms-3">
        <Subheading
          Icon={SolutionsIcon}
          heading="Solutions Library"
          subheading="Select a pre-built Solution to suit your requirement ."
        />
      </div>

      <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 mb-5">
        <div className="fw-bold text-navy text-center fs-2">
          What is a Solution?
        </div>
        <div>
          A Solution is a pre-built workflow that you can purchase and deploy in
          your workspace. It can be created by you, other users in the
          community, or by our team. Solutions can be used as they are or
          customized to fit your specific needs. Browse through the library to
          find the perfect Solution for your use case.
        </div>
      </div>

      <StyledTabContainer isBackgroundFixed id="solutions-library-tabs">
        <Tab.Container
          id="solutions-tabs"
          activeKey={
            filters.purchased === "yes" ? "my-solutions" : "system-solutions"
          }
          onSelect={(v) => {
            setFilters({
              ...filters,
              purchased: v === "my-solutions" ? "yes" : "any",
              offset: 0,
            });
          }}
          mountOnEnter
        >
          <Nav
            variant="solutions-tabs"
            defaultActiveKey="components"
            className="mb-n1"
          >
            <div className="flex-grow-1"></div>
            {tabs.map((tab, i) => (
              <Nav.Item
                className="d-flex justify-content-end "
                key={tab.eventKey}
              >
                <Nav.Link
                  eventKey={tab.eventKey}
                  className="fw-bold d-flex justify-content-between rounded-top-4 border-0"
                  style={{ width: 150 }}
                >
                  <div className="mt-1">{tab.heading}</div>
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="my-solutions">
              <MySolutionFilter filters={filters} setFilters={setFilters} />
            </Tab.Pane>
            <Tab.Pane eventKey="system-solutions">
              <SystemSolutionsFilter
                filters={filters}
                setFilters={setFilters}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </StyledTabContainer>
    </div>
  );
}
